<template>
  <div>
    <img 
      v-if="imageUrl"
      :src="imageUrl"
      :alt="altText || 'Profile Image'"
      class="w-24 h-24 md:w-32 md:h-32 object-cover rounded-md shadow-md border border-gray-200"
      @error="handleImageError"
    />
    <div 
      v-else
      class="w-24 h-24 md:w-32 md:h-32 bg-gray-100 rounded-md shadow-inner flex items-center justify-center border border-gray-200"
    >
      <v-icon color="grey-lighten-1" size="48">mdi-image-off</v-icon>
      <span class="sr-only">{{ altText || 'Missing image' }}</span>
    </div>
    <p v-if="caption && imageUrl" class="text-xs text-gray-500 mt-1 text-center">{{ caption }}</p>
    <p v-if="!imageUrl && missingText" class="text-xs text-gray-500 mt-1 text-center">{{ missingText }}</p>
  </div>
</template>

<script>
export default {
  name: 'ImagePreviewDisplay',
  props: {
    imageUrl: {
      type: String,
      default: ''
    },
    altText: {
      type: String,
      default: 'Image'
    },
    caption: {
      type: String,
      default: ''
    },
    missingText: {
      type: String,
      default: 'Image not available'
    }
  },
  methods: {
    handleImageError(event) {
      event.target.src = ''; // Clear src to trigger the v-else condition or show a placeholder
      // Optionally, emit an event or log the error
      console.warn('Image failed to load:', this.imageUrl);
    }
  }
};
</script>

<style scoped>
/* Add any specific styling if needed */
</style> 